import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from '__utils/type';
import { Row, Col } from 'antd';
import onlineTransaction from 'images/upiWaiting.svg';
import UpiForm from '../upi-payment/upi-form';
import { LayoutContext } from 'components/app-routes';
import UserBankInfoSlab from '../user-bank-info-slab';
import { WhiteCardWrapper } from 'views/common-styled-components';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js'
import PaymentViewSelector from '../payment-flow.selector';
import UpiSteps from '../upi-payment/upi-details';
import { addAgentCode } from '__utils/common-utils';

const OuterCont = styled.div<CommonStyledComponentProps>`
  
`;

const AwaitingForUpi: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { totalValidOrdersAmount } = propsToJS(useSelector(PaymentViewSelector));
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const flash = useFlashToggler();

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'UPI Payment' },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'UPI Payment', url: '' } ],
            showCopyrightInfoForDesktop: true,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return <OuterCont isMobile={ isMobile }>

        { isMobile && <div style={ { margin: '16px', marginTop: '60px' } }>
            <UserBankInfoSlab />
        </div> }
        <Row gutter={ 32 } style={ { width: '100%', margin: '0px auto', padding: '0' } }>
            <Col xs={ 24 } md={ 16 } style={ { padding: '0' } }>
                <WhiteCardWrapper isMobile={ isMobile } style={ { width: isMobile ? '90vw' : '100%',height: isMobile?'' :'100%'} }>
                    <Row style={ { marginTop: '8px', flexDirection: isMobile ? 'column-reverse' : 'row' } }>
                        <Col xs={ 24 } md={ 11 }>
                            { !isMobile && <div>
                                <UserBankInfoSlab vertical /> <br />
                            </div> }
                            <UpiForm />
                        </Col>
                        <Col xs={ 24 } md={ 13 }>
                            <img src={ onlineTransaction } style={ { width: "100%" } } />
                        </Col>

                    </Row>
                    { isMobile && <UpiSteps /> }

                </WhiteCardWrapper>
            </Col>

            <Col xs={ 0 } md={ 8 } style={ { padding: '0 0 0 32px ' } }>
                <div className='mint-box flex-col-container' style={ { height: '100%',justifyContent:'flex-start' } }>
                    { !isMobile && <>
                        <Row style={ { justifyContent: 'space-between' } }>
                            <Col style={ { color: '#4D5556', fontSize: '18px' } }>
                                Total Investment :
                            </Col>
                            <Col >
                                <b className='totalAmountTitle'> ₹ { totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) }/-</b>
                            </Col>
                        </Row>
                    </>
                    }<br /><br/>
                    { !isMobile && <UpiSteps /> }
                </div>
            </Col>
        </Row>

    </OuterCont>
}
export default AwaitingForUpi;